import { Box } from '@olist/united';

const Container = (props) => <Box maxWidth="1280px" mx="auto" px={3} width={1} {...props} />;

export default Container;
